module.exports = __webpack_public_path__ + "static/media/utensils-alt.fa5880cd.svg";